import styled from 'styled-components'

export const ClientViewCampaignsWrapper = styled.div`
  margin: 30px -15px 0 -15px;

  .campaign-card {
    cursor: pointer;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Clients/ClientView/ClientViewCampaignsWrapper/index.js